// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1wQcs","assignButton":"CreateEditEquipmentSchedule_assignButton__PzShr"};